// Analytics utility for GA4 and PostHog event tracking

// GA4 Event Tracking
export const trackGA4Event = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// PostHog Event Tracking
export const trackPostHogEvent = (eventName, properties = {}) => {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.capture(eventName, properties);
  }
};

// Track both GA4 and PostHog
export const trackEvent = (eventName, properties = {}) => {
  trackGA4Event(eventName, properties);
  trackPostHogEvent(eventName, properties);
};

// Identify user (PostHog)
export const identifyUser = (userId, traits = {}) => {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.identify(userId, traits);
  }
};

// Pre-defined events for the app
export const Analytics = {
  // Auth Events
  loginStarted: () => trackEvent('login_started'),
  loginCompleted: (method = 'google') => trackEvent('login_completed', { method }),
  loginFailed: (reason) => trackEvent('login_failed', { reason }),
  logout: () => trackEvent('logout'),
  
  // Business Verification Events
  verificationStarted: () => trackEvent('verification_started'),
  verificationStep1Completed: (companySize) => trackEvent('verification_step1_completed', { company_size: companySize }),
  verificationStep2Started: () => trackEvent('verification_step2_started'),
  verificationCompleted: () => trackEvent('verification_completed'),
  verificationSkipped: () => trackEvent('verification_skipped'),
  
  // Browsing Events
  pageView: (pageName) => trackEvent('page_view', { page_name: pageName }),
  categoryViewed: (category) => trackEvent('category_viewed', { category }),
  bundleViewed: (bundleId, bundleName, price) => trackEvent('bundle_viewed', { 
    bundle_id: bundleId, 
    bundle_name: bundleName,
    price 
  }),
  solutionViewed: (solutionId, solutionName) => trackEvent('solution_viewed', { 
    solution_id: solutionId, 
    solution_name: solutionName 
  }),
  
  // Comparison & TCO Events
  comparisonPageViewed: () => trackEvent('comparison_page_viewed'),
  bundleSelected: (bundleId, bundleName) => trackEvent('bundle_selected', { 
    bundle_id: bundleId, 
    bundle_name: bundleName 
  }),
  packageSelected: (packageId, packageName) => trackEvent('package_selected', { 
    package_id: packageId, 
    package_name: packageName 
  }),
  tcoViewed: (bundleIds) => trackEvent('tco_viewed', { bundle_ids: bundleIds }),
  
  // Conversion Events
  offerRequestStarted: (bundleId) => trackEvent('offer_request_started', { bundle_id: bundleId }),
  offerRequestCompleted: (bundleId, bundleName, price, hasPackage) => trackEvent('offer_request_completed', { 
    bundle_id: bundleId,
    bundle_name: bundleName,
    price,
    has_support_package: hasPackage
  }),
  
  // Search Events
  searchPerformed: (query, resultsCount) => trackEvent('search_performed', { 
    search_query: query, 
    results_count: resultsCount 
  }),
  
  // CTA Clicks
  ctaClicked: (ctaName, location) => trackEvent('cta_clicked', { 
    cta_name: ctaName, 
    location 
  }),
};

export default Analytics;
